import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    Stack,
    Typography
} from "@mui/material";
import {AlertTriangle, RefreshCw, X} from "lucide-react";
import {formatMoney} from "../financeiroUtils";

export default function FaturaReprocessDialog({open, fatura, loading = false, onClose, onConfirm}) {
    if (!open || !fatura) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{'& .MuiDialog-paper': {borderRadius: 2}}}>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 3, borderBottom: '1px solid #e5e7eb'}}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box sx={{width: 40, height: 40, borderRadius: '999px', bgcolor: '#ffedd5', display: 'grid', placeItems: 'center'}}>
                        <RefreshCw size={18} color="#ea580c" />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{color: '#111827', fontWeight: 600}}>
                            Reprocessar Fatura
                        </Typography>
                        <Typography variant="body2" sx={{color: '#6b7280'}}>
                            Fatura #{fatura.id}
                        </Typography>
                    </Box>
                </Stack>
                <IconButton onClick={onClose}>
                    <X size={20} color="#6b7280" />
                </IconButton>
            </Box>

            <DialogContent sx={{p: 3}}>
                <Stack spacing={2.5}>
                    <Box sx={{bgcolor: '#fff7ed', border: '1px solid #fdba74', borderRadius: 2, p: 2}}>
                        <Stack direction="row" spacing={1} alignItems="flex-start">
                            <AlertTriangle size={18} color="#ea580c" style={{marginTop: 2}} />
                            <Box>
                                <Typography variant="body2" sx={{color: '#9a3412', fontWeight: 600, mb: 0.5}}>
                                    Atenção: Esta ação não pode ser desfeita!
                                </Typography>
                                <Typography variant="body2" sx={{color: '#9a3412'}}>
                                    A fatura atual será cancelada e uma nova será gerada automaticamente utilizando as regras de faturamento mais recentes.
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                    <Box sx={{bgcolor: '#f9fafb', borderRadius: 2, p: 2}}>
                        <Typography variant="body2" sx={{color: '#374151', fontWeight: 500, mb: 1.5}}>
                            Fatura Atual
                        </Typography>
                        <Stack spacing={1}>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="body2" sx={{color: '#4b5563'}}>Competência:</Typography>
                                <Typography sx={{color: '#111827'}}>{fatura.competencia || '-'}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="body2" sx={{color: '#4b5563'}}>Valor Total:</Typography>
                                <Typography sx={{color: '#111827'}}>{formatMoney(fatura.valor_total)}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="body2" sx={{color: '#4b5563'}}>Status:</Typography>
                                <Typography sx={{color: '#111827'}}>{fatura.status || '-'}</Typography>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant="body2" sx={{color: '#4b5563'}}>Itens:</Typography>
                                <Typography sx={{color: '#111827'}}>{Array.isArray(fatura.itens) ? fatura.itens.length : '-'}</Typography>
                            </Stack>
                        </Stack>
                    </Box>

                    <Box sx={{bgcolor: '#f9fafb', borderRadius: 2, p: 2}}>
                        <Typography variant="body2" sx={{color: '#374151', fontWeight: 500, mb: 1.5}}>
                            O que acontecerá:
                        </Typography>
                        <Stack spacing={1}>
                            {[
                                'A fatura atual será marcada como CANCELADA',
                                'Uma nova fatura será gerada com os mesmos parâmetros',
                                'As regras de faturamento atualizadas serão aplicadas',
                                'Mensalidade, opcionais, desconto e excedente por métrica serão recalculados',
                                'Uma nova data de vencimento será definida',
                            ].map((item, index) => (
                                <Stack key={item} direction="row" spacing={1}>
                                    <Typography variant="body2" sx={{color: '#9ca3af'}}>{index + 1}.</Typography>
                                    <Typography variant="body2" sx={{color: '#4b5563'}}>{item}</Typography>
                                </Stack>
                            ))}
                        </Stack>
                    </Box>
                </Stack>
            </DialogContent>

            <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1.5, px: 3, pb: 3, pt: 0}}>
                <Button variant="outlined" onClick={onClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="contained" color="warning" onClick={onConfirm} disabled={loading} startIcon={<RefreshCw size={16} />}>
                    Confirmar Reprocessamento
                </Button>
            </Box>
        </Dialog>
    );
}
